import { render } from "./CreateFormModal.vue?vue&type=template&id=21c901e2"
import script from "./CreateFormModal.vue?vue&type=script&lang=js"
export * from "./CreateFormModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__